module.exports = __webpack_public_path__ + "img/party-icon.83be46a1.svg";